import { Locale } from 'components/core/locale/types';

export const UpdateChildTranslations = {
  [Locale.English]: {
    UpdateChildTranslations: {
      pageTitle: `{ isSelf, select,
        true {Additional Information}
        false {My Child or Teen}
        other {}
      }`,
      ccPageTitle: "Let's get to know {name}",
      ccAdultPageTitle: "Additional Information",
      ccPageSubtitle: 'Please review and add information about {name}.',
      firstName: 'First Name',
      lastName: 'Last Name',
      addNickname: 'Add a preferred name',
      nickName: 'Preferred name',
      birthDate: 'Birth Date',
      sex: 'Sex',
      gender: 'Gender',
      addPreferredPronouns: 'Add preferred pronouns',
      pronouns: 'Preferred Pronouns',
      raceEthnicity: 'Race/Ethnicity (select all that apply)',
      address: 'Address',
      street1: 'Street 1',
      street2: 'Street 2',
      city: 'City',
      state: 'State',
      zipCode: 'Zip Code',
      pharmacy: 'Pharmacy',
      milesFromZip: 'Miles from zip',
      selectYourPharmacy: 'Select your pharmacy',
      save: 'Save',
    },
  },
};
